import styles from 'css/src/components/emails.module.scss';
import 'css/src/global';

import React from 'react';

import { Urls } from 'js/src/client';
import NotificationManagement from 'js/src/components/common/notification-management';
import PageErrorBoundary from 'js/src/components/common/ui/ErrorBoundary';
import { getQueryParam } from 'js/src/libs/querystring';

/*
 * REQUIRED QUERY PARAMS:
 *  - id: user id
 *  - secret: user's email_secret_uuid
 *  - category: email category to auto-unsubscribe
 */
const Emails = React.memo(function Emails() {
    return (
        <PageErrorBoundary>
            <div className={`${styles['unsubscribe-page']} page-container`}>
                <div className="header">
                    <span className="d-block mb-l5-48 pt-l5-48 text-center">
                        <a href={Urls.HOME}>
                            <img
                                src="https://cdn.lumen5.com/lumen5-site-images/L5-logo/2024/Lumen5-PrimaryLogo.svg"
                                width="125"
                                alt="Lumen5"
                            />
                        </a>
                    </span>
                </div>

                <div className="page-content">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-6 mx-l5-auto pt-l5-48">
                                    <NotificationManagement
                                        user_id={parseInt(getQueryParam('id') ?? '')}
                                        email_secret_uuid={getQueryParam('secret') ?? ''}
                                        unsub_on_load={getQueryParam('category')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`${styles['footer']} text-muted text-center copyright py-l5-32`}>
                    &copy; {`${new Date().getFullYear()}`} Lumen5
                </div>
            </div>
        </PageErrorBoundary>
    );
});

export default Emails;
